import { HOME } from './path';

export const HOMEPAGE = 'homepage';

// Map connecting path type to landing page type
const landingPageTypePathTypeMap = {
  [HOME]: HOMEPAGE,
};

export default landingPageTypePathTypeMap;
